import { render, staticRenderFns } from "./InvoiceStatusWidget.vue?vue&type=template&id=0f2273b2&"
import script from "./InvoiceStatusWidget.vue?vue&type=script&lang=js&"
export * from "./InvoiceStatusWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports